"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Typeahead.css");
var _Selector = _interopRequireDefault(require("../../../Selector/Selector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Typeahead = _ref => {
  let {
    tabIndex = 1,
    placeholder = "Search By Ticker Or Name",
    updateSelection,
    token,
    clientEmail,
    currentSelection,
    dataspanApiUrl
  } = _ref;
  const [inputValue, setInputValue] = (0, _react.useState)('');
  const [options, setOptions] = (0, _react.useState)([]);
  const [loading, setLoading] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (inputValue.length > 1) {
      getSuggestions(inputValue);
    } else {
      setOptions([]);
    }
  }, [inputValue]);
  const getSuggestions = async query => {
    setLoading(true);
    const url = "".concat(dataspanApiUrl, "/fundchar/typeahead/?wtRegion=US");
    if (token) {
      const requestUrl = new URL(url);
      requestUrl.searchParams.append('clientEmail', clientEmail);
      requestUrl.searchParams.append('q', query);
      try {
        const response = await fetch(requestUrl, {
          method: 'GET',
          headers: {
            Authorization: "Token ".concat(token)
          }
        });
        if (response.ok) {
          const data = await response.json();
          const suggestions = Array.isArray(data) ? data : [];
          const safeCurrentSelection = Array.isArray(currentSelection) ? currentSelection : [];
          const filteredSuggestions = suggestions.filter(suggestion => !safeCurrentSelection.some(fund => fund.externalID === suggestion.externalID));
          setOptions(filteredSuggestions.map(suggestion => ({
            value: suggestion.externalID,
            label: "".concat(suggestion.ticker, " ").concat(suggestion.name),
            ticker: suggestion.ticker,
            name: suggestion.name,
            externalID: suggestion.externalID
          })));
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleChange = selectedOption => {
    updateSelection(selectedOption);
    setOptions(options.filter(option => option.value !== selectedOption.value));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "select-container"
  }, /*#__PURE__*/_react.default.createElement(_Selector.default, {
    autoFocus: false,
    tabIndex: tabIndex,
    placeholder: placeholder.toUpperCase(),
    value: null,
    inputValue: inputValue,
    onInputChange: value => setInputValue(value),
    options: options,
    isLoading: loading,
    onChange: handleChange,
    onFocus: () => setInputValue(''),
    menuIsOpen: options.length > 0
  }));
};
var _default = exports.default = Typeahead;